import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";  
import { mapLicDetails } from "@/redux/mappers/Import/EOUitem/EouitemMaper"

export const MainShipmentApi = createApi({
  reducerPath: "MainShipmentApi",
  baseQuery,   
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("userToken");
    if (token) headers.set("Authorization", `Bearer ${token}`);
    headers.set("X-Request-Id", crypto.randomUUID());
    return headers;
  },
  tagTypes: ["Lic","mainShipment"],
  endpoints: (builder) => ({
    
    createMainShipment: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/shipment/main/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: {shipment:data}, 
      }),
      invalidatesTags: ["mainShipment"],
    }),

    getMainShipmentById: builder.query({
      query: ({id}) => `/export/shipment/main/${id}`,
      transformResponse: (response) => response?.data?.[0]?? [],
      providesTags: ["mainShipment"],
    }),

    getLic: builder.query({
      query: () => `/master/lic`,
      transformResponse: (response) => {
        return response?.data?.map(mapLicDetails);
      },
      providesTags: ["Lic"],
    }),

    getImportBondType: builder.query({
      query: (params) => ({
        url : `import/bond`,
        params,
        method: "GET",
      }),
      transformResponse: (response) => {
        console.log(response,"response")
        return response?.data?.data;
      },
      providesTags: ["Lic"],
    }) 

    
  }),
});

export const {
  useCreateMainShipmentMutation,
  useLazyGetMainShipmentByIdQuery,
  useGetLicQuery,
  useGetImportBondTypeQuery,
    useLazyGetImportBondTypeQuery

} = MainShipmentApi;
